// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-holder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.step {
  width: 60%;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-top: 1em;
  padding: 0.6em 0.5em;
  background-color: white;
  color: #3d2929;
}

.row > .step-heading,
.step-status {
  padding: 5px 0px 0px 10px;
}

.step-heading {
  display: inline-flex;
  gap: 7px;
}

.step-heading h6 {
  margin-bottom: none;
}

.status-bullet {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 11px;
  gap: 8px;
  border: none;
  border-radius: 20px;
  margin: 0 auto;
  cursor: text !important;
}

.lable {
  line-height: 20px;
  font-size: 10px;

  font-family: sans-serif;
  letter-spacing: 1px;
}

.detail-button {
  border-radius: 8px;
  padding: 5px 34px;
  font-size: 14px;
  color: var(--primary-color);
  background: white;
  font-weight: 500;
  border: none;
}

.active-step {
  background-color: var(--primary-color);
  color: white;
}

.active-step > .status-bullet .lable {
  color: white !important;
}

.step-details {
  margin-left: 1.6em;
}

.step-details p {
  margin-top: 0.5em;
  font-size: small;
}

.status-completed {
  background: #1ce0a321;
  color: #1ce0a3;
}

.status-in-progress {
  background: #e3f9df3d;
  color: white;
}

.steps-submission {
  width: 60%;
  margin: 3em;
}

.steps-submission button {
  color: var(--white);
  float: right;
  padding: 8px 23px;
  border-radius: 8px;
  border: none;
  background: var(--primary-color);
  font-size: 14px;
  font-weight: 400;
}
.steps-submission button {
  color: var(--disabled-text);
  border: 1px solid var(--disabled-text);
  border-radius: 8px;
  background: var(--disabled);
}

.completed {
  cursor: pointer;
}

.completed:hover {
  background: #e0d3fa;
}

/* Disabled steps css */

.disabled {
  color: #afafaf;
  background: #f1f6fe;
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/view/steps.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;;EAEf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;;AAEvB;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".steps-holder {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.step {\n  width: 60%;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  margin-top: 1em;\n  padding: 0.6em 0.5em;\n  background-color: white;\n  color: #3d2929;\n}\n\n.row > .step-heading,\n.step-status {\n  padding: 5px 0px 0px 10px;\n}\n\n.step-heading {\n  display: inline-flex;\n  gap: 7px;\n}\n\n.step-heading h6 {\n  margin-bottom: none;\n}\n\n.status-bullet {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1px 11px;\n  gap: 8px;\n  border: none;\n  border-radius: 20px;\n  margin: 0 auto;\n  cursor: text !important;\n}\n\n.lable {\n  line-height: 20px;\n  font-size: 10px;\n\n  font-family: sans-serif;\n  letter-spacing: 1px;\n}\n\n.detail-button {\n  border-radius: 8px;\n  padding: 5px 34px;\n  font-size: 14px;\n  color: var(--primary-color);\n  background: white;\n  font-weight: 500;\n  border: none;\n}\n\n.active-step {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.active-step > .status-bullet .lable {\n  color: white !important;\n}\n\n.step-details {\n  margin-left: 1.6em;\n}\n\n.step-details p {\n  margin-top: 0.5em;\n  font-size: small;\n}\n\n.status-completed {\n  background: #1ce0a321;\n  color: #1ce0a3;\n}\n\n.status-in-progress {\n  background: #e3f9df3d;\n  color: white;\n}\n\n.steps-submission {\n  width: 60%;\n  margin: 3em;\n}\n\n.steps-submission button {\n  color: var(--white);\n  float: right;\n  padding: 8px 23px;\n  border-radius: 8px;\n  border: none;\n  background: var(--primary-color);\n  font-size: 14px;\n  font-weight: 400;\n}\n.steps-submission button {\n  color: var(--disabled-text);\n  border: 1px solid var(--disabled-text);\n  border-radius: 8px;\n  background: var(--disabled);\n}\n\n.completed {\n  cursor: pointer;\n}\n\n.completed:hover {\n  background: #e0d3fa;\n}\n\n/* Disabled steps css */\n\n.disabled {\n  color: #afafaf;\n  background: #f1f6fe;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
